export default "__VITE_ASSET__DAVmFEE6__"